<!--<app-use-app-notification></app-use-app-notification>-->
<!--</nav>-->
<div class="mini-header ">
    <div class="d-flex pull-left">
        <app-language-icon></app-language-icon>
        <app-currency-icon></app-currency-icon>

    </div>

    <div class="d-flex flex-row-reverse">
        <app-store-icon></app-store-icon>
    </div>


</div>

<!--<div class="d-flex pl-3 pr-3" style="    background-color: #34c7c7;-->
<!--    padding-top: 20px;-->
<!--    padding-bottom: 25px;">-->

<!--    <div class="flex-md-grow-0 flex-grow-1">-->
<!--        <a [routerLink]="'/'"><img src="assets/logo_white.png" class="img" style="max-width: 220px;"/></a>-->
<!--    </div>-->


<!--    <div class="d-none d-md-block flex-grow-1" style="    margin: auto;-->
<!--    text-align: center;-->
<!--}">-->
<!--        <app-searchbar></app-searchbar>-->
<!--    </div>-->
<!--    <div class=" d-flex">-->

<!--        <a href="{{env.store360link}}" target="_blank">-->
<!--            <span class="icon_360_new" i18n="@@store360_new">New</span>-->
<!--            <button class="btn_360" mat-button-->
<!--                    style="margin-right: 10px;padding-right: 5px !important; padding-left: 5px !important;">-->
<!--            <span>-->
<!--               <span> <img style="width: 26px;margin: 8px;margin-right: 8px;margin-left: 8px;"-->
<!--                           src="assets/icon_360.png"/>-->
<!--                   </span>-->
<!--                <span class="btn_360_text" i18n="@@store360">360 Store</span>-->
<!--        </span>-->
<!--            </button>-->
<!--        </a>-->
<!--        <app-cart-icon style="    margin-right: 30px;"></app-cart-icon>-->
<!--        <app-login-icon></app-login-icon>-->


<!--    </div>-->


<!--</div>-->


<nav class="d-sm-flex navbar navbar-light bg-light"
     style="background-color: #34c7c7 !important;">

    <!--    <app-searchbar></app-searchbar>-->
    <a class="navbar-brandflex-grow-1 " href="#">
        <a [routerLink]="'/'"><img src="assets/logo_white.png" class="img"
                                   style="max-width: 220px; "/></a>
    </a>
    <div class="d-none d-md-block flex-sm-grow-1" style="background-color: #34c7c7 !important;">
        <app-searchbar></app-searchbar>
    </div>

    <div class="d-flex">
        <div style="margin-top: 10px;" >
            <a href="{{env.store360link}}" target="_blank" class="btn_360"><img
                    style="width: 23px;margin: 0px;margin-right: 5px;"
                    src="assets/icon_360.png"/></a>

        </div>
        <div >
            <app-cart-icon></app-cart-icon>
        </div>
         <div class="d-none d-sm-none d-md-block">     <app-login-icon></app-login-icon></div>
        <button class="navbar-toggler d-block d-sm-block d-md-none" type="button" data-toggle="collapse" data-target="#navbarMainMenu"
                aria-controls="navbarMainMenu" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>

    </div>
    <div class="collapse navbar-collapse" id="navbarMainMenu">

        <app-menu-mobile-bs></app-menu-mobile-bs>
    </div>

</nav>


<div class="d-sm-block d-md-none" style="background-color: #34c7c7 !important;">
    <app-searchbar></app-searchbar>
</div>

<div class="main">
    <app-menu></app-menu>
    <div class="container-fluid" id="navigation" style="padding-left: 65px; font-weight: bold">

    </div>
</div>


